<template>
	<div class="main-container">

		<!-- Navbar section -->
		<Header />

		<!-- hero section -->
		<Hero />

		<!-- service section -->
		<AboutWhaleio />

		<!-- feature section -->
		<WhaleioValues />

		<!-- team component -->
        <!--
		<div class="team-member-wrapper section-space--ptb_120 default-bg" id="team">
            <div class="container">
                <WhaleioLeadership />
            </div>
        </div>
		-->

		<!-- contact us section -->
		<ContactAgency />

		<!-- footer section -->
        <FooterMain />
	</div>
</template>

<script>

	import Header from "@/components/Header";
	import Hero from "@/components/sections/Hero";
	import AboutWhaleio from "@/components/sections/AboutWhaleio";
	import WhaleioValues from "@/components/sections/WhaleioValues";
	import ContactAgency from "@/components/sections/ContactAgency";
	import FooterMain from "@/components/FooterMain";
	//import WhaleioLeadership from '@/components/WhaleioLeadership'

	export default {
		name: "app",
		components: {
			Header,
			Hero,
			AboutWhaleio,
			WhaleioValues,
			ContactAgency,
            FooterMain//,
			//WhaleioLeadership
		},

		metaInfo: {
            title: 'Whaleio LLC',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        },
		
		mounted(){
            document.documentElement.scrollTop = 0;
		}
	};
</script>

<style lang="scss">
	@import '../assets/scss/_variabls.scss';
    @import '../assets/scss/page-section/_digital-agency.scss';
</style>

